import React from 'react'
import FormGerenteCambista from '../_Components/FormGerenteCambista'
import { getUsuarioFromStorage } from '../Utils/usuarioHelper'
import qs from 'qs'
import MasterTemplate from '../_Master/MasterTemplate'
import { Link } from 'react-router-dom';


const CadastroGerente = (props) => {
    const { id } = qs.parse(props.location.search, { ignoreQueryPrefix: true })
    const tutorId = JSON.parse(localStorage.getItem("user"))._id

    return (
        <MasterTemplate label="Cadastro de Gerentes">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Cadastro de Gerentes</h4>
                            </div>
                            <div className="card-body">
                                <FormGerenteCambista perfil="GERENTE" tutorId={tutorId} id={id}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MasterTemplate>

    )
}

export default CadastroGerente
